import { FiMenu, FiX } from "react-icons/fi";
import { ReactComponent as Logo } from '../assets/logo.svg';
import { useState } from "react";
import { Link } from "react-scroll";
import useModal from "../hooks/useModal";
import Modal from "./Modal";
import PDF from "../assets/piima.pdf";

const Header = () => {
  const activo = "underline decoration-red-700 decoration-2 underline-offset-4";
  const { open, close, isOpen } = useModal()
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navItems = (
    <>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="nosotros" smooth={true} duration={500}>Nosotros</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="servicios" smooth={true} duration={500}>Servicios</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="solicitar" smooth={true} duration={500}>Contacto</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="opiniones" smooth={true} duration={500}>Testimonios</Link>
      <button onClick={open} className={`${activo}`}>Politica de integridad</button>
    </>
  );

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-amber-400 shadow px-4 py-3 flex justify-between items-center text-white">
      <Logo className="w-auto h-32"/>
      <nav className="hidden md:flex gap-6 text-sm font-medium">
        {navItems}
      </nav>
      <div className="md:hidden">
        <button onClick={toggleMenu} aria-label="Toggle Menu">
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>
      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-start gap-4 p-4 text-sm font-medium z-40">
          {navItems}
        </div>
      )}
      {isOpen &&
        <Modal onClose={close}>
          <iframe
            src={PDF}
            title="Política de Integridad"
            className="w-full h-full rounded-xl border border-gray-300 shadow"
          />
        </Modal>
      }
    </header>
  );
};

export default Header;